import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DownloadSimpleIcon } from '@yonderland/andes-icons';
import { Icon, Link, TextAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { FALLBACK_LANG, getProductManualDocument } from '../../../util/ManualUtil';
const DownloadManualSection = ({ productManual, manualBaseUrl, lang, filteredProductManualKeys, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    return (_jsxs(Link, { testId: "product_manual", href: manualBaseUrl + getProductManualDocument(filteredProductManualKeys, lang, productManual, FALLBACK_LANG), target: "_blank", rel: "noopener", variant: "secondary", children: [_jsx(Icon, { source: DownloadSimpleIcon, size: "sm" }), _jsx(TextAlpha, { strong: true, children: t('pdp.manual.download') })] }));
};
export default DownloadManualSection;
